import { AnyAction, combineReducers, EnhancedStore } from '@reduxjs/toolkit';
import { ThunkMiddleware } from 'redux-thunk';
import type { records } from '@saucelabs/sl-module-user';
import { Location } from 'history';

import filterBar from './ducks/filterBar';
import diffUi from './ducks/diffUi';

const reducers = {
  filterBar,
  diffUi,
};

const rootReducer = combineReducers(reducers);

export default rootReducer;

export type VisualAppState = {
  apps: {
    visual: ReturnType<typeof rootReducer>,
  },
  user: records.UserRecord,
  router: {
    location: Location,
  },
};

export type VisualAppDispatch = EnhancedStore<VisualAppState, AnyAction, [ThunkMiddleware]>['dispatch'];
